import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { ContinueWithBackAndTempSaveButtons } from 'components/base/BottomStepComponent';
import {
  defaultPreviewImage,
  getPreviewLayoutImages,
} from 'components/campaign/campaignCreation/CampaignStepTwoPreviewConfig';

import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { CREATE_CAMPAIGN_CONTENT_PAGE_CONFIG } from 'containers/engagement/campaignStreamline/CreateCampaignContentPageConfig';
import { ActionType, APIStatus, CampaignType } from 'config/CustomEnums';
import PublishCampaignPrompt from 'components/campaign/campaignCreation/PublishCampaignPrompt';
import RequireCampaignNamePrompt from 'components/campaignStreamline/RequireCampaignNamePrompt';
import { scrollToAnchor } from 'components/campaignStreamline/CreateCampaignHandleError';
const CreateMessageCampaignContentPage = ({
  anchorKey,
  sectionKey,
  createStatus,
  formHasSubmitted,
  saveDraftAction = () => { },
}) => {
  const params = useParams();
  const isEditMode = !!params.id
  const dispatch = useDispatch();
  const formContext = useFormContext()
  const {
    watch,
    formState: { errors },
    setValue,
  } = formContext;
  const watchName = watch('translations.en.generalName');
  const [showRequireNamePrompt, setShowRequireNamePrompt] = useState(false);
  const [showPublishPrompt, setShowPublishPrompt] = useState(false);

  const errorLanguage = Object.keys(errors?.translations || [])?.[0];

  const campaignTypeField = 'campaignType';
  const watchCampaignType = watch(campaignTypeField);

  const [fieldsError, setFieldsError] = useState(Object.keys(errors || []).length);

  const defaultImage = defaultPreviewImage(CampaignType.generalMessageCampaign);
  const inputWithImageConfig = getPreviewLayoutImages(CampaignType.generalMessageCampaign);

  useEffect(() => {
    if (!isEditMode && watchCampaignType !== CampaignType.generalMessageCampaign) {
      setValue(campaignTypeField, CampaignType.generalMessageCampaign, { shouldDirty: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, watchCampaignType])


  useEffect(() => {
    if (createStatus === APIStatus.success && formHasSubmitted) {
      setShowPublishPrompt(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createStatus, formHasSubmitted]);

  useEffect(() => {
    setFieldsError(Object.keys(errors || []).length);
  }, [errors]);

  useEffect(() => {
    scrollToAnchor(anchorKey, sectionKey);
  }, [anchorKey, sectionKey]);


  const stepChangeAction = (step) => {
    setFieldsError(0);
    dispatch({
      type: 'campaignStreamline/stepChange',
      payload: { step: step },
    });
  };
  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATE_CAMPAIGN_CONTENT_PAGE_CONFIG}
        hidePreview={false}
        fieldsError={fieldsError}
        errorLanguage={errorLanguage}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultImage}
        sectionStyle='create-campaign-streamline-step-2'
      />
      <ContinueWithBackAndTempSaveButtons
        {...isEditMode ? {} : {
          saveTempText: "Save as draft",
          saveTempAction: () => {
            if (!watchName) {
              setShowRequireNamePrompt(true);
              return;
            };
            saveDraftAction(formContext);
          }
        }}
        continueAction={() => {
          stepChangeAction(1);
        }}
      />
      <RequireCampaignNamePrompt
        show={showRequireNamePrompt}
        onHide={() => {
          setShowRequireNamePrompt(false);
        }}
        onConfirm={() => {
          setShowRequireNamePrompt(false);
          saveDraftAction(formContext);
        }}
      />
      <PublishCampaignPrompt
        campaignId={params.id}
        campaignType={CampaignType.generalMessageCampaign}
        actionType={ActionType.save}
        show={showPublishPrompt}
        path={'/messages'}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  anchorKey: state.campaignStreamline.anchorKey,
  sectionKey: state.campaignStreamline.sectionKey,
  createStatus: state.createCampaign.createStatus,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
});

export default connect(mapStateToProps)(CreateMessageCampaignContentPage);

